import { render, staticRenderFns } from "./FollowUserTweet.vue?vue&type=template&id=e9822948&scoped=true&"
import script from "./FollowUserTweet.vue?vue&type=script&lang=js&"
export * from "./FollowUserTweet.vue?vue&type=script&lang=js&"
import style0 from "./FollowUserTweet.vue?vue&type=style&index=0&id=e9822948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9822948",
  null
  
)

export default component.exports